import { render } from "./DispositionReminderModal.vue?vue&type=template&id=1a3f25c7&scoped=true"
import script from "./DispositionReminderModal.vue?vue&type=script&lang=js"
export * from "./DispositionReminderModal.vue?vue&type=script&lang=js"

import "./DispositionReminderModal.vue?vue&type=style&index=0&id=1a3f25c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3f25c7"]])

export default __exports__